import { MfaModel } from './../models/account-ledger.model';
import { OnDestroy, Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { CurrentUserModel } from '../models/account-ledger.model';
import { catchError, shareReplay, tap } from 'rxjs/operators';
// tslint:disable-next-line:import-blacklist
import { Subject, BehaviorSubject } from 'rxjs';
import { ApiResponse } from '../models/api-response.model';
import { PostcodeList } from '../models/account-delivery-address';
import { IMenu } from '../models/imenu.model';



// This service will be used in future for login/logout/refresh features and to handle user/client exceptions

@Injectable()
export class AuthService implements OnInit, OnDestroy {
    baseUrl = '/account';
    isAuthenticated = false;
    currentUserModel: CurrentUserModel = {} as CurrentUserModel;

    public menuLoadingCompleted = false;

    public MENU_SECTION_1: IMenu[] = [];
    public MENU_SECTION_2: IMenu[] = [];
    public MENU_SECTION_3: IMenu[] = [];
    public MENU_SECTION_4: IMenu[] = [];

    ngUnsubscribe: Subject<void> = new Subject<void>();

    private watchLoginInfoSubject = new BehaviorSubject<CurrentUserModel>(this.currentUserModel);
    currentLoginInfoWatch = this.watchLoginInfoSubject.asObservable();


    constructor(private http: HttpClient) {

        this.currentLoginInfoWatch = this.http.get<CurrentUserModel>(this.baseUrl + '/getlogininfo')
            .pipe(tap(res => this.monitorLoginInfoChange(res)), shareReplay(1), catchError(this.handleError));
    }

    ngOnInit() {

        if (this.currentUserModel == null) {
            this.isAuthenticated = true;
        }
    }

    currentUserHasPurchaseAccess(): boolean {
        return this.currentUserModel?.hasPurchaseAccess;
    }

    currentUserHasAdminAccess(): boolean {
        return this.currentUserModel?.hasAdminAccess
    }

    monitorLoginInfoChange(loginInfo: CurrentUserModel): void {
        this.currentUserModel = loginInfo;
        this.watchLoginInfoSubject.next(loginInfo);
    }


    getLoginInfo(): Observable<CurrentUserModel> {

        return this.currentLoginInfoWatch;
        // return this.http.get<CurrentUserModel>(this.baseUrl + '/getlogininfo')
        //     .pipe(tap(res => this.monitorLoginInfoChange(res)), catchError(this.handleError));
    }

    sendMfaRegistrationCode(model: MfaModel): Observable<any> {
        return this.http.post(this.baseUrl + '/SendMfaRegistrationCode', model)
            .pipe(catchError(this.handleError));
    }

    validateMfaCode(mfaCode: string): Observable<any> {
        return this.http.get(this.baseUrl + '/ValidateMfaCode?mfaCode=' + mfaCode)
            .pipe(catchError(this.handleError));
    }


    handleError(error: any) {
        // tslint:disable-next-line:no-debugger
        // debugger;
        // console.log('server error:', error);
        // below needs to be updated in future with all scenarios based on client session .....
        // skip error status 502 bad gateway
        const genericErrorMsg = 'Something went wrong. Please try again later. If the error persists, please contact support.';
        if (error instanceof HttpErrorResponse) {
            // It's an HttpErrorResponse.
            console.error(
              `Backend returned code ${error.status}, body was: `,
              error.error
            );
            if (error.status === 500) {
              console.error('Internal Server Error (500) detected!');
              return throwError(genericErrorMsg);
            } else if (error.status !== 200 && error.status !== 502 && error.name === 'HttpErrorResponse') {
                // logout redirect, window object used since below is not part of client routing
                // /window.location.pathname = '/404';
                return throwError(error.name);
            } else {
                if (error.error instanceof ErrorEvent) {
                    let errMessage = '';
                    try {
                        errMessage = error.error.message;
                    } catch (err) {
                        errMessage = error.statusText;
                    }
                    return throwError(errMessage);
                }
                return throwError(error.error || genericErrorMsg);
            }
          } else {
            // It's likely a client-side or network error.
            console.error('An error occurred:', error);
          }
          return throwError(genericErrorMsg);
    }

    OCLogout(): Observable<ApiResponse> {
        return this.http.get<ApiResponse>(this.baseUrl + '/OCILogout')
            .pipe(catchError(this.handleError));
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }    

    GetPostCodeList(suburbSearchKey: string, postcode: string): Observable<PostcodeList[]> {
        if (suburbSearchKey == "") {
            return this.http.get<PostcodeList[]>(this.baseUrl + '/GetPostCodeList?postcode=' + encodeURIComponent(postcode))
                .pipe(catchError(this.handleError));
        }
        else {
            return this.http.get<PostcodeList[]>(this.baseUrl + '/GetPostCodeList?suburbSearchKey=' + encodeURIComponent(suburbSearchKey))
                .pipe(catchError(this.handleError));
        }
    }

}
